import {Component, Injector} from "@angular/core";
import {Translations} from "@translations";
import {SimAutoUpdateService, SimMaterialDialogService, NotificationService} from "@services";
import {EventEmitterService} from "@event-emitter";
import {MatDialogRef} from "@angular/material/dialog";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_UpdateSimStationDialogInput extends MatDialogDataBaseInput {}

export interface DialogData_UpdateSimStationDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-update-simstation-dialog",
	templateUrl: "./update-sim-station-dialog.component.html",
	styleUrls: ["./update-sim-station-dialog.component.scss"],
	standalone: false,
})
export class UpdateSimStationDialogComponent extends BasicMaterialDialog<
	UpdateSimStationDialogComponent,
	DialogData_UpdateSimStationDialogInput,
	DialogData_UpdateSimStationDialogOutput
> {
	constructor(
		private _simMaterialDialogService: SimMaterialDialogService,
		private _simAutoUpdateService: SimAutoUpdateService,
		private _emitterService: EventEmitterService,
		private _simNotificationService: NotificationService,
		private thisDialogRef: MatDialogRef<UpdateSimStationDialogComponent>,
		_injector: Injector,
	) {
		super(_injector);
		this._emitterService.onSimStationUpdateDownloadProgress.subscribe((value) => {
			this.downloadProgress = value.downloadProgress;
		});
		this._emitterService.onSimStationUpdateFinished.subscribe((value) => {
			this.isDownloading = false;
			this.isInstalling = true;
		});
	}

	protected readonly Translations = Translations;
	isDownloading: boolean = false;
	downloadProgress: number = 0;
	isInstalling: boolean = false;

	updateSimStation() {
		console.trace("Update SIMStation clicked.");
		this._simMaterialDialogService
			.openGeneralWarningDialog({
				warningOkText: "Update",
				warningDescription: "Do you really want to update SIMStation? Updating SIMStation might take up to 20 minutes.",
				warningTitle: "Update SIMStation",
			})
			.then((dialogResponse) => {
				if (dialogResponse.action === "ok") {
					this.isDownloading = true;
					this.thisDialogRef.disableClose = true;
					this._simAutoUpdateService
						.triggerAutoUpdate()
						.then((response) => {
							this._simNotificationService.notifySuccess("Update Process started");
							console.trace("Update SIMStation Process started");
						})
						.catch((error) => {
							this._simNotificationService.notifyError("Update Process failed to start");
							this.isDownloading = false;
							this.thisDialogRef.disableClose = false;
							console.error("Update SIMStation Process failed to start.", error);
						});
				}
			});
	}
}
